<div class="flex flex-col">
  @for (member of list(); track member.id) {
    <div class="flex gap-3 p-2 justify-between rounded-lg cursor-pointer card" (click)="onMemberClick(member)">
      <div class="flex flex-1 min-w-0 gap-4">
        <div class="size-[3.5rem] shrink-0">
          <app-user-avatar-v2 [user]="member" />
        </div>
        <div class="flex flex-col min-w-0">
          <span
            class="truncate text-[1.125rem]/[160%] font-medium text-[#2C3035]"
            [title]="member.isDeleted ? ('common.deletedAccount' | translate: { id: member.id }) : member.fullName"
          >
            {{ member.isDeleted ? ('common.deletedAccount' | translate: { id: member.id }) : member.fullName }}
          </span>
          <span class="text-[1.125rem]/[160%] text-[#505760]">{{ member.userTypeName }}</span>
        </div>
      </div>
      <div class="flex shrink-0 items-center gap-4">
        <span class="text-[1.125rem]/[160%] text-[#2C3035]"
          >{{ member?.leaves }} {{ 'my-forest.leaves' | translate }}</span
        >
        <i>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              d="M5.07757 2.81295C4.87157 3.00821 4.87157 3.3248 5.07757 3.52006L9.80347 7.99984L5.07757 12.4796C4.87157 12.6749 4.87157 12.9914 5.07757 13.1867C5.28356 13.382 5.61749 13.382 5.82348 13.1867L10.9224 8.35338C11.1284 8.15811 11.1284 7.84157 10.9224 7.64631L5.82348 2.81295C5.61749 2.61769 5.28356 2.61769 5.07757 2.81295Z"
              fill="#2C3035"
            />
          </svg>
        </i>
      </div>
    </div>
  }
</div>
